// Password visibility toggle — appends an eye icon button to each
// password input so users can reveal / hide the value.
//
// Usage:  call initPasswordToggles() after the relevant DOM is ready.
// It is safe to call multiple times — existing buttons are skipped.
window.initPasswordToggles = function () {
  var showTemplate = document.getElementById('password-toggle-icon-show');
  var hideTemplate = document.getElementById('password-toggle-icon-hide');
  if (!showTemplate || !hideTemplate) return;

  var labelShow = showTemplate.getAttribute('data-label') || 'Show password';
  var labelHide = hideTemplate.getAttribute('data-label') || 'Hide password';

  var inputs = document.querySelectorAll('input[type="password"]');

  for (var i = 0; i < inputs.length; i++) {
    var input = inputs[i];

    // Find a positioned container — Devise auth pages use these classes,
    // the admin sidebar uses SimpleForm's .a__form--wrapper.
    var container = input.closest(
      '.password-input-container, .password-input-container-label, .a__form--wrapper, .profile-sidebar__wrapper'
    );

    // No suitable container — skip gracefully (no DOM reparenting).
    if (!container) continue;

    // Already initialised — skip.
    if (container.querySelector('.password-toggle-btn')) continue;

    input.classList.add('password-toggle-input');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'password-toggle-btn';
    btn.setAttribute('aria-label', labelShow);
    btn.setAttribute('tabindex', '-1');

    // Clone the "show" icon from the <template> (avoids innerHTML).
    btn.appendChild(showTemplate.content.cloneNode(true));

    btn.addEventListener('click', (function (inp, b) {
      return function () {
        var isPassword = inp.type === 'password';
        inp.type = isPassword ? 'text' : 'password';
        b.setAttribute('aria-label', isPassword ? labelHide : labelShow);

        // Swap icon: remove current, clone the other template's content.
        while (b.firstChild) b.removeChild(b.firstChild);
        var tpl = isPassword ? hideTemplate : showTemplate;
        b.appendChild(tpl.content.cloneNode(true));
      };
    })(input, btn));

    container.appendChild(btn);
  }
};
